export const IconFeature = ({ text, icon }) => {
  return <div className="flex flex-col items-center w-full xs:max-w-24 justify-center">
    <div className="pb-4">{icon}</div>
    <p className="text-2xl font-normal text-white text-center" dangerouslySetInnerHTML={{__html: text}} />
  </div>
}